import { render } from "./LayoutComponent.vue?vue&type=template&id=376a772a&scoped=true&ts=true"
import script from "./LayoutComponent.ts?vue&type=script&lang=ts"
export * from "./LayoutComponent.ts?vue&type=script&lang=ts"

import "./LayoutComponent.scss?vue&type=style&index=0&id=376a772a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/maximum/maximum/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376a772a"]])

export default __exports__